import { Box, Stack, Typography } from "@mui/material";
import { StatCard } from "../components";
import { StatCardInterface } from "../interfaces";
import { useOrdersCount, useScreenSize } from "../hooks";
import { globalTheme } from "../styles";

export const StatCardContainer = () => {
  const { belowDesktop } = useScreenSize();
  const dashboardOrdersCardStats = useOrdersCount();

  const lastOrderTimestamp = dashboardOrdersCardStats.lastOrderTimeStamp[0]?.count;

  const formattedDateTime = lastOrderTimestamp
    ? new Date(lastOrderTimestamp).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
    : "Not Available";

  return (
    <>
      <Stack
        direction={belowDesktop ? "column" : "row"}
        justifyContent="space-around"
        maxWidth="100%"
        margin={5}
        spacing={1}
        gap={15}
        overflow="hidden"
        textOverflow="ellipsis"
      >
        {dashboardOrdersCardStats.orderStatData.map((item: StatCardInterface, key: number) => {
          return <StatCard key={key} {...item} />;
        })}
      </Stack>

      <Stack flexDirection="row">
        <Typography
          variant="subtitle2"
          component="span"
          sx={{
            backgroundColor: globalTheme.background,
            color: globalTheme.primaryColor,
            p: 1,
            borderRadius: "16px 0px 0px 16px",
            width: "fit-content",
            fontSize: "24px",
          }}
          ml={5}
        >
          Last Sync Timestamp:
        </Typography>

        <Typography
          variant="subtitle2"
          component="span"
          sx={{
            backgroundColor: globalTheme.background,
            color: globalTheme.primaryColor,
            p: 1,
            borderRadius: "0px 16px 16px 0px",

            width: "fit-content",
            fontSize: "24px",
          }}
        >
          {formattedDateTime}
        </Typography>
      </Stack>
    </>
  );
};
